// extracted by mini-css-extract-plugin
module.exports = {"outer":"Scrollable_outer__3brqZ","inner":"Scrollable_inner__2Spzk","outsideScrollbar":"Scrollable_outsideScrollbar__3BmII"};